import { Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import LandingPage from './pages/LandingPage.jsx';
import ComingSoonPage from './pages/ComingSoonPage.jsx';
import CookiesPage from './pages/CookiesPage.jsx';
import PrivacidadPage from './pages/PrivacidadPage.jsx';
import TerminosPage from './pages/TerminosPage.jsx';
import NotFoundPage from './pages/NotFoundPage.jsx';

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname, hash]);
  return null;
}

export default function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        {/* TODO(launch): site is in "Coming Soon" mode. To flip to the full
            landing when ready to launch:
              1. Change the "/" route below to <LandingPage />.
              2. Either delete the "/landing" route or repoint it to
                 <ComingSoonPage /> as a permanent preview URL.
              3. In src/pages/ComingSoonPage.jsx, switch <Header variant="minimal" />
                 back to "landing" if you reuse Coming Soon as a real page.
              4. Update README.md routes table. */}
        <Route path="/" element={<ComingSoonPage />} />
        <Route path="/landing" element={<LandingPage />} />
        <Route path="/cookies" element={<CookiesPage />} />
        <Route path="/privacidad" element={<PrivacidadPage />} />
        <Route path="/terminos" element={<TerminosPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </>
  );
}
